var __webpack_exports__ = {};
/*!***********************************!*\
  !*** ./src/scripts/fostr-menu.js ***!
  \***********************************/
class FostrMenu extends HTMLElement {
  constructor() {
    super();
    this.menuItem =  this.querySelectorAll('.header__menu-item.has-submenu');
    this.itemNoMega =  this.querySelectorAll('.header__menu-item:not(.has-submenu):not(.submenu-list-menu__item)');
    this.stickyHeader = document.querySelector('#shopify-section-header');
    this.menuContent = this.querySelector('.header_submenu-container')
    this.dawnSubmenu = this.querySelector('details-disclosure')
    this.menuItem.forEach( menuItem => {
      menuItem.addEventListener(
        'mouseover',
        this.onItemOver.bind(this)
      );
    })
    this.itemNoMega.forEach( menuItem => {
      menuItem.addEventListener(
        'mouseover',
        this.onItemOverNoMega.bind(this)
      );
    })
    if (this.dawnSubmenu) {
      this.dawnSubmenu.addEventListener(
        'click',
        this.onDawnItemClick.bind(this)
      );
    }
    this.stickyHeader.addEventListener(
        'mouseleave',
        this.onStickyHeaderLeave.bind(this)
    );
    this.stickyHeader.addEventListener(
      'mouseenter',
      this.onStickyHeaderEnter.bind(this)
    );
  }

  onItemOverNoMega(event) {
    // remove function you dont want to hide the opened nav when another item of the nav is over
    this.close(event);
  }

  onItemOver(event) {
    this.close(event);
    if (!event.target.closest('li').hasAttribute('open')) {
      event.target.closest('li').setAttribute('open', 'true');
      this.open(event);
    }
  }

  onDawnItemClick(event) {
    this.close(event);
  }
  resetLi() {
    if (this.menuItem.length > 0) {
      this.menuItem.forEach( menuItem => {
        if (menuItem.closest('li[open]')) {
          menuItem.closest('li[open]').removeAttribute('open')
        }
      })
    }
  }

  close(event) {
    if (event.target.classList.contains('header__menu-item')) {
      if (!event.target.closest('li').hasAttribute('open')) {
        this.menuContent.classList.remove('display-nav')
        this.menuContent.querySelectorAll('nav').forEach( nav =>  {
          nav.classList.add('hidden');
          nav.classList.remove('display-item');
          this.resetLi()
        })
      }
    } else if(event.target === this.stickyHeader) {
      this.menuContent.classList.remove('display-nav')
      this.menuContent.querySelectorAll('nav').forEach( nav => {
        setTimeout(() => {
          nav.classList.add('hidden');
          nav.classList.remove('display-item');
          this.resetLi()
        }, 200);
      })
    }
  }

  open(event) {
    this.menuContent.classList.remove('hidden')
    this.menuContent.classList.add('display-nav')
    this.menuContent.querySelector(`.menu-${event.target.dataset.menu}`).classList.remove('hidden')
    setTimeout(() => {
      this.menuContent.querySelector(`.menu-${event.target.dataset.menu}`).classList.add('display-item')
    }, 1);
    this.onStickyHeaderEnter()
  }

  onStickyHeaderLeave(event) {
    event.target.classList.add('leaving');
    setTimeout(() => {
      if (event.target.classList.contains('leaving')) {
        this.close(event);
        event.target.classList.remove('header-hover')
        setTimeout(() => {
          this.menuContent.classList.add('hidden')
        }, 200);
      }
    }, 450);
  }

  onStickyHeaderEnter() {
    this.stickyHeader.classList.remove('leaving');
    this.stickyHeader.classList.add('header-hover')
  }
}
customElements.define('fostr-menu', FostrMenu)

